import React from 'react';

import { GrowthBookPageWrapper, injectGrowthBookProps } from '../../utils/growth-book';
import { Offer, Placeholder } from '../../src/client/types/__codegen__/sanity/graphql';
import { STATIC_BUILD_REVALIDATE_TIME } from '../../src/client/ahm-constants/ui';
import getOffersContent from '../utils/get-offers-content';
import getShouldSkipClientSideRequest from '../../src/client/utils/get-should-skip-client-side-request';
import OffersPage from '../../src/client/pages/offers';
import useGetOffersContent from '../utils/use-get-offers-content';

export type OffersLandingPageProps = {
  activeOffers: Offer[];
  placeholders: Placeholder[];
};

const OffersLandingPage = ({
  activeOffers: serverSideOffers,
  placeholders: serverSidePlaceholders,
}: OffersLandingPageProps) => {
  const shouldSkip = getShouldSkipClientSideRequest();
  const { activeOffers, placeholders, loading: isLoading } = useGetOffersContent({ shouldSkip });

  const useServerSideContent = shouldSkip || isLoading;

  const content = {
    activeOffers: useServerSideContent ? serverSideOffers : activeOffers,
    placeholders: useServerSideContent ? serverSidePlaceholders : placeholders,
  };

  return <OffersPage {...content} />;
};

export const getStaticProps = async () => {
  const content = await getOffersContent();
  const payload = await injectGrowthBookProps({
    // The resolved url is unknown during SSG or ISR (getStaticProps),
    // since during the build the baseURL is unknowable (eg sales-dev01.ahm.ninja).
    // Targeting on URL can only be used client-side or server-side (SSR).
    context: { resolvedUrl: null },
    props: {
      ...content,
    },
  });

  return {
    ...payload,
    revalidate: STATIC_BUILD_REVALIDATE_TIME,
  };
};

// @ts-expect-error - Automatic, Please fix when editing this file
export default function WrappedPage(props) {
  // @ts-expect-error - Automatic, Please fix when editing this file
  return GrowthBookPageWrapper(props, OffersLandingPage);
}
